import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { AppBar, Container, Box, Typography, Link } from '@mui/material'

// Branding bar tied to edpro.ua: the EdPro logo links back to the main site,
// the "Ресурси" wordmark links to the catalog root. Stacks vertically on
// narrow viewports so the logo and wordmark never collide.
export default function AppHeader() {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        top: 0,
        zIndex: (t) => t.zIndex.appBar,
        boxShadow: '0 1px 8px rgba(0, 0, 0, 0.06)',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
            gap: { xs: 1, sm: 2 },
            py: { xs: 1.5, sm: 1 },
            minHeight: 56,
          }}
        >
          <Link
            href="https://edpro.ua"
            rel="noopener"
            sx={{ display: 'inline-flex', alignItems: 'center' }}
          >
            <Box
              component="img"
              src="/edpro-logo.png"
              alt="EdPro"
              sx={{ height: 36, width: 'auto', display: 'block' }}
            />
          </Link>
          <Link
            component={RouterLink}
            to="/"
            underline="none"
            color="inherit"
            sx={{ display: 'inline-flex', alignItems: 'baseline', gap: 1 }}
          >
            <Typography
              variant="h6"
              sx={{ fontFamily: '"Nunito", sans-serif', fontWeight: 800 }}
            >
              Ресурси
            </Typography>
          </Link>
        </Box>
      </Container>
    </AppBar>
  )
}
